import axiosInstance from "./axiosInstance";

const urls = {
  recentReports: "/management/report/reports/recent/",
};

/**
 * 유저의 최근 신고를 가져오는 API
 * @param {} page
 * @param {*} userId
 * @param {*} headers
 * @returns
 */
export async function fetchRecentReports(page, userId, headers) {
  try {
    const response = await axiosInstance.django.get(urls.recentReports, {
      params: {
        page: page,
        user_id: userId,
      },
      headers: headers,
    });
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error("Failed to fetch recent reports");
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchReports(page, userId, headers) {
  try {
    const response = await axiosInstance.django.get(
      "/management/report/reports/",
      {
        params: {
          page: page,
          user_id: userId,
        },
        headers: headers,
      }
    );
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error("Failed to fetch reports");
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchReportById(reportId, headers) {
  try {
    const response = await axiosInstance.django.get(
      `/management/report/reports/${reportId}/`,
      {
        headers: headers,
      }
    );
    if (response.status === 200) {
      return response.data.data;
    }
    throw new Error("Failed to fetch report detail");
  } catch (error) {
    console.error("fetchReportById", error);
    throw error;
  }
}

export async function fetchReportReasonKeysAiEvaludated(reportId, headers) {
  try {
    const response = await axiosInstance.django.get(
      `/report/v1/reports/${reportId}/report-reasons-ai-evaluated/`,
      {
        headers: headers,
      }
    );
    if (response.status === 200) {
      return response.data.data;
    } else {
      throw new Error("Failed to fetch report reason keys ai evaluated");
    }
  } catch (error) {
    console.error("fetchReportReasonKeysAiEvaludated", error);
    throw error;
  }
}

/**
 * 선택된 신고 사유 기준으로 control preview 정보를 가져온다.
 * @param {number|string} reportId
 * @param {{reasonId?: number, reportReason?: string}} payload
 * @param {*} headers
 * @returns {Promise<Object>}
 */
export async function fetchControlPreview(reportId, payload = {}, headers) {
  try {
    const body = {};
    if (payload.reasonId) {
      body.reason_id = payload.reasonId;
    }
    if (payload.reportReason) {
      body.report_reason = payload.reportReason;
    }
    const response = await axiosInstance.django.post(
      `/management/report/reports/${reportId}/control-preview/`,
      body,
      {
        headers: headers,
      }
    );
    if (response.status === 200) {
      return response.data;
    }
    throw new Error("Failed to fetch control preview");
  } catch (error) {
    console.error("fetchControlPreview", error);
    throw error;
  }
}

export async function banUser(userId, domains, reasonKeyId, headers) {
  try {
    const response = await axiosInstance.django.post(
      "/management/report/ban/",
      {
        user_id: userId,
        domains: domains,
        reason_key_id: reasonKeyId
      },
      {
        headers: headers,
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Failed to ban user");
    }
  } catch (error) {
    console.error("banUser", error);
    throw error;
  }
}

export async function getBanReasons(headers) {
  try {
    const response = await axiosInstance.django.get(
      "/management/report/ban/reasons/",
      {
        headers: headers,
      }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Failed to fetch ban reasons");
    }
  } catch (error) {
    console.error("getBanReasons", error);
    throw error;
  }
}
